



































import { Component, Prop, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { Action } from '@/api/model/action'
import { ActionType, ActionAppointmentType } from '@/api/types'
import { Branch } from '@/api/model/branch'

export interface CreateActionModel {
    type?: ActionType,
    appointmentType?: ActionAppointmentType,
    actionDate?: Date,
    assignedTo?: User[],
    comment?: string,
    notify: boolean,
}

@Component
export default class CreateActionForm extends Vue {
    @Prop() readonly value!: CreateActionModel
    @Prop({ type: Boolean, default: false }) readonly hideType!: boolean
    @Prop({ type: Boolean, default: false }) readonly canCreateAppointment!: boolean
    @Prop() readonly formTitle!: string
    @Prop() readonly branch!: Branch

    get actionTypeOptions(): Array<{ label: string, value: string }> {
        let options = Action.availableTypes.map(value => {
            return {
                label: this.$t(`action.type.${value}`).toString(),
                value,
            }
        })

        if (this.canCreateAppointment === false) {
            options = options
                .filter(option => option.value !== ActionType.MEETING)
        }

        return options
    }

    get actionAppointmentTypeOptions(): Array<{ label: string, value: string }> {
        return Action.availableAppointmentTypes.map(value => {
            return {
                label: this.$t(`action.appointmentType.${value}`).toString(),
                value,
            }
        })
    }

    get sortedUsers() {
        return this.$currentCompany.getAvailableUsers({ branch: this.branch })
            .sort((a: User, b: User) => a.name.localeCompare(b.name))
            .sort(((a: User) => a.id === this.$currentUser.id ? -1 : 1))
    }

    get isAppointmentType() {
        return this.value.type === ActionType.MEETING
    }
}
